import React from 'react';
import { TableProps } from './types';
import { renameDomProps } from '@/utils/sanitizeDomProps';

const Table: React.FC<TableProps> = ({
  headers,
  rows,
  spacingTop,
  spacingBottom,
  ...rest
}) => {
  const renamedProps = renameDomProps(rest);

  return (
    <div
      className={`table-container ${
        spacingTop && spacingBottom
          ? 'py-4 md:py-8 lg:py-20'
          : spacingTop
            ? 'pt-4 md:pt-8 lg:pt-20'
            : spacingBottom
              ? 'pb-4 md:pb-8 lg:pb-20'
              : ''
      }`}
      {...renamedProps}
    >
      <div className="container mx-auto grid grid-cols-12 gap-6 px-4 sm:px-0">
        <div className="col-start-1 col-end-13 flex flex-col gap-6 overflow-auto lg:col-start-3 lg:col-end-11 xl:col-start-4 xl:col-end-10">
          <table className="w-full border-collapse">
            <thead>
              <tr>
                {headers.map((header) => (
                  <th
                    className="w-1/3 border border-gray-300 bg-brand-100 p-6 text-start text-lg font-medium"
                    key={header.id}
                  >
                    {header.tableHeader}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((row, rowIndex) => (
                <tr key={row.id}>
                  {row.cells.map((cell, cellIndex) => (
                    <td
                      className={`border border-gray-300 p-6 text-start text-base font-normal ${
                        cellIndex === 0 ? 'font-bold' : ''
                      } ${rowIndex === 0 ? 'border-t-0' : ''}`} // Remove top border for the first row
                      key={cell.id}
                    >
                      {cell.cells}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Table;
